(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hygienie-cost-check"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHCC(root){
    if(!root || root.__hccInit) return;
    root.__hccInit = true;

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('.hcc-config').textContent); } catch(e){}

    var num = function(v,d){ var n = parseFloat(v); return isNaN(n) ? d : n; };
    var decode = function(s){ var t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; };

    var C = {
      symbol: decode(cfg.symbol) || '£',
      rollPrice: num(cfg.rollPrice, 2.95),
      laundryCost: num(cfg.laundryCost, 1.70),
      rollLength: num(cfg.rollLength, 50),
      metresPerClient: num(cfg.metresPerClient, 2),
      lede: decode(cfg.lede) || 'Based on your answers, your business could be spending around [amount] a year on couch roll and laundry.'
    };

    var clientsPerRoll = (C.rollLength > 0 && C.metresPerClient > 0) ? (C.rollLength / C.metresPerClient) : 25;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var q  = function(s){ return root.querySelector(s); };
    var qa = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var card = q('[data-card]');
    var quiz = q('[data-view="quiz"]');
    var results = q('[data-view="results"]');
    var panels = qa('[data-step]');
    var fill = q('.hcc-progress__fill');
    var progressNum = q('[data-progress-num]');
    var backBtn = q('[data-back]');
    var nextBtn = q('[data-next]');
    var TOTAL = 4, current = 1, started = false, busy = false;

    qa('[data-symbol]').forEach(function(el){ el.textContent = C.symbol; });

    var clientsEl = q('[data-field="clients"]');
    var rollPriceEl = q('[data-field="rollPrice"]');
    var costPerLoadEl = q('[data-field="costPerLoad"]');
    var loadsEl = q('[data-field="loads"]');
    var outEl = q('[data-field="outsourced"]');

    if(rollPriceEl) rollPriceEl.value = C.rollPrice.toFixed(2);
    if(costPerLoadEl) costPerLoadEl.value = C.laundryCost.toFixed(2);

    function fmtMoney(n){ return C.symbol + Math.round(n).toLocaleString('en-GB'); }
    function fmtInt(n){ return Math.round(n).toLocaleString('en-GB'); }
    function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    /* animate the card's height around any DOM change */
    function morph(change){
      if(reduce || !card){ change(); return; }
      var h0 = card.offsetHeight;
      change();
      var h1 = card.offsetHeight;
      if(h0 === h1) return;
      card.style.overflow = 'hidden';
      card.style.transition = 'none';
      card.style.height = h0 + 'px';
      void card.offsetHeight;
      card.style.transition = 'height .45s cubic-bezier(.22,.61,.36,1)';
      card.style.height = h1 + 'px';
      clearTimeout(card.__hccT);
      card.__hccT = setTimeout(function(){
        card.style.height = '';
        card.style.transition = '';
        card.style.overflow = '';
      }, 480);
    }

    function laundryType(){
      var c = root.querySelector('[data-field="laundryType"]:checked');
      return c ? c.value : '';
    }
    function panelFor(step){
      return panels.filter(function(p){ return p.getAttribute('data-step') === String(step); })[0];
    }
    function showError(step, msg, field){
      var el = panelFor(step) && panelFor(step).querySelector('[data-error]');
      morph(function(){
        if(el){ el.textContent = msg; el.hidden = false; }
      });
      if(field){ field.classList.add('is-invalid'); field.focus({preventScroll:true}); }
    }
    function clearError(step){
      var el = panelFor(step) && panelFor(step).querySelector('[data-error]');
      if(el && !el.hidden){ morph(function(){ el.hidden = true; }); }
      qa('.hcc__input').forEach(function(i){ i.classList.remove('is-invalid'); });
    }

    function syncStep4(){
      var t = laundryType();
      ['own','external','none'].forEach(function(k){
        var b = root.querySelector('[data-when="'+k+'"]');
        if(b) b.hidden = (k !== t);
      });
    }

    function goTo(step, back){
      var prev = current;
      current = step;
      morph(function(){
        panels.forEach(function(p){
          var active = (p.getAttribute('data-step') === String(step));
          p.hidden = !active;
          p.classList.remove('is-active','is-back');
          if(active){
            if(back) p.classList.add('is-back');
            void p.offsetWidth;
            p.classList.add('is-active');
          }
        });
        if(step === 4) syncStep4();
      });

      if(fill) fill.style.width = (step / TOTAL * 100) + '%';
      if(progressNum) progressNum.textContent = ('0' + step).slice(-2);
      backBtn.disabled = (step === 1);
      nextBtn.textContent = (step === TOTAL) ? 'See my results' : 'Continue';

      if(started && step !== prev){
        var panel = panelFor(step);
        var h = panel && panel.querySelector('[data-when]:not([hidden]) .hcc__q, .hcc__q');
        if(h) h.focus({preventScroll:true});
      }
    }

    function positive(el){
      if(!el) return 0;
      var v = parseFloat(el.value);
      return (isNaN(v) || v <= 0) ? 0 : v;
    }

    function validate(step){
      clearError(step);
      if(step === 1 && !positive(clientsEl)){
        showError(1, 'Enter how many clients you treat each week.', clientsEl); return false;
      }
      if(step === 2 && !positive(rollPriceEl)){
        showError(2, 'Enter a couch roll price greater than zero.', rollPriceEl); return false;
      }
      if(step === 3 && !laundryType()){
        showError(3, 'Choose how you manage your laundry to continue.'); return false;
      }
      if(step === 4){
        var t = laundryType();
        if(t === 'own'){
          if(!positive(loadsEl)){ showError(4, 'Enter how many laundry loads you do each week.', loadsEl); return false; }
          if(!positive(costPerLoadEl)){ showError(4, 'Enter a cost per load greater than zero.', costPerLoadEl); return false; }
        }
        if(t === 'external' && !positive(outEl)){
          showError(4, 'Enter your weekly laundry spend.', outEl); return false;
        }
      }
      return true;
    }

    function compute(){
      var clients = positive(clientsEl);
      var rollPrice = positive(rollPriceEl) || C.rollPrice;
      var annualClients = clients * 52;
      var annualRolls = annualClients / clientsPerRoll;
      var rollSpend = annualRolls * rollPrice;

      var t = laundryType(), laundrySpend = 0, laundryLine = 'No laundry';
      if(t === 'own'){
        var loads = positive(loadsEl);
        var costPer = positive(costPerLoadEl) || C.laundryCost;
        laundrySpend = loads * costPer * 52;
        laundryLine = fmtMoney(laundrySpend) + ' a year';
      } else if(t === 'external'){
        laundrySpend = positive(outEl) * 52;
        laundryLine = fmtMoney(laundrySpend) + ' a year';
      }

      return { total: rollSpend + laundrySpend, annualClients: annualClients, annualRolls: annualRolls, laundryLine: laundryLine };
    }

    function countUp(el, target){
      if(!el) return;
      if(reduce){ el.textContent = fmtMoney(target); return; }
      var start = null, dur = 900;
      function frame(ts){
        if(!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = fmtMoney(target * (1 - Math.pow(1 - p, 3)));
        if(p < 1) requestAnimationFrame(frame);
        else el.textContent = fmtMoney(target);
      }
      requestAnimationFrame(frame);
    }

    /* cross-fade one view out, the other in, inside the same card */
    function swap(from, to, after){
      if(busy) return;
      busy = true;
      var finish = function(){
        morph(function(){
          from.hidden = true;
          to.hidden = false;
          to.classList.add('is-out');
        });
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){
            to.classList.remove('is-out');
            if(after) after();
            busy = false;
          });
        });
      };
      if(reduce){ from.classList.remove('is-out'); finish(); return; }
      from.classList.add('is-out');
      setTimeout(function(){
        from.classList.remove('is-out');
        finish();
      }, 300);
    }

    function showResults(){
      var d = compute();
      q('[data-snap="clients"]').textContent = fmtInt(d.annualClients);
      q('[data-snap="rolls"]').textContent = fmtInt(d.annualRolls);
      q('[data-snap="laundry"]').textContent = d.laundryLine;
      q('[data-snap="spend"]').textContent = fmtMoney(d.total);

      var lede = q('[data-lede]');
      if(lede) lede.innerHTML = esc(C.lede).replace('[amount]', '<strong>' + esc(fmtMoney(d.total)) + '</strong>');

      var fig = q('[data-figure]');
      if(fig) fig.textContent = fmtMoney(0);

      swap(quiz, results, function(){ countUp(fig, d.total); });
      scrollToTop();
    }

    function scrollToTop(){
      var rect = root.getBoundingClientRect();
      if(rect.top < 0 || rect.top > window.innerHeight * 0.4){
        root.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'});
      }
    }

    function reset(){
      if(clientsEl) clientsEl.value = '';
      if(rollPriceEl) rollPriceEl.value = C.rollPrice.toFixed(2);
      if(costPerLoadEl) costPerLoadEl.value = C.laundryCost.toFixed(2);
      if(loadsEl) loadsEl.value = '';
      if(outEl) outEl.value = '';
      qa('[data-field="laundryType"]').forEach(function(r){ r.checked = false; });
      [1,2,3,4].forEach(clearError);
      started = false;
      goTo(1);
      swap(results, quiz);
      scrollToTop();
    }

    nextBtn.addEventListener('click', function(){
      started = true;
      if(!validate(current)) return;
      if(current < TOTAL) goTo(current + 1, false);
      else showResults();
    });
    backBtn.addEventListener('click', function(){
      started = true;
      if(current > 1) goTo(current - 1, true);
    });
    q('[data-reset]').addEventListener('click', reset);

    root.addEventListener('keydown', function(e){
      if(e.key === 'Enter' && e.target.classList && e.target.classList.contains('hcc__input')){
        e.preventDefault();
        nextBtn.click();
      }
    });
    root.addEventListener('input', function(){ clearError(current); });
    root.addEventListener('change', function(){ clearError(current); });

    goTo(1);
  }

  function boot(scope){
    (scope || document).querySelectorAll('.hcc[data-hcc]').forEach(initHCC);
  }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function(){ boot(); });
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
